import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchDropDown } from '../../common/form/FieldHelper';

class PriceBookDropdown extends Component {

  render() {

    const {
      name,
      form,
      fetchDropdown,
      className = 'field',
      currency,
      valueField = 'price_book_reference',
    } = this.props;

    return (
      <div className={className}>
        <Field
          {...this.props}
          component={renderSearchDropDown}
          dropdownType='price_book_reference'
          fields={[
            'id',
            'name',
            'retail_price',
            'available_to',
            'available_from',
            'price_book_reference',
            'currency_id'
          ]}
          formId={form}
          getBy='price_book_reference'
          name={name}
          searchFn={fetchDropdown}
          searchParams={{
            currency_id: currency
          }}
          textFn={(doc) => doc.id ? `${doc.price_book_reference} : ${doc.name}` : null}
          valueField={valueField}
          type='price_book'
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(PriceBookDropdown);

